import React from 'react';
import { Theme } from '@radix-ui/themes';

export default function ThemeProvider({ children }) {
  return (
    <Theme accentColor="green" grayColor="sage" radius="large" scaling="100%">
      {children}
    </Theme>
  );
}
